export default "__VITE_ASSET__c30bbb8a__$_?nuxt_component=async&nuxt_component_name=SvgoHelp2952994__"